import {
  agreementAndPostAgreementDocsLabelsAndValues,
  mfaRiderSubCategories
} from "../../../utils/coco-acquired.config";

import {
  validDocumentTypes,
  validStoreTypes
} from "../../../utils/document-constants";
import {
  validCocoAcquiredLicenses,
  nocForGstSubCategories,
  ElectricityBillInNameOfLandloadSubCategories
} from "../../../utils/coco-acquired.config";
import {
  showCocoAcquiredLicenseTypeBoxInForm,
  preAgreementDocsSelectList
} from "../utils/coco-acquired-utils";
import { getLabelsAndValuesForSelect } from "../../../../common-utilities/utils";
import {
  agreementAndPostAgreementDocsConfig,
  mfaRiderConfig,
  preAgreementDocsConfig,
  electricityBillInNameOfLandloadConfig,
  nocForGstConfig
} from "../sub-configs/coco-acquired";
import { waterTestingConfig } from "../sub-configs/coco-built";

export const cocoAcquiredInputsForForm = (
  formDetails,
  errors,
  storeType,
  isEditingDoc,
  docs
) => {
  if (storeType !== validStoreTypes.cocoAcquired) {
    return {};
  }
  const cocoAcquiredLicenses = Object.values(validCocoAcquiredLicenses);
  const cocoAcquiredLicensesLabels = getLabelsAndValuesForSelect(
    cocoAcquiredLicenses,
    cocoAcquiredLicenses
  );

  const preAgreementSelectLabelsAndValues = preAgreementDocsSelectList();

  const agreementAndPostAgreementSelectList = Object.values(
    agreementAndPostAgreementDocsLabelsAndValues
  );
  const agreementAndPostAgreementLabelsAndValues = getLabelsAndValuesForSelect(
    agreementAndPostAgreementSelectList,
    agreementAndPostAgreementSelectList
  );

  const mfaRiderSubCategoriesList = Object.values(mfaRiderSubCategories);
  const nocForGstSubCategoriesList = Object.values(nocForGstSubCategories);
  const electricityBillInNameOfLandloadSubCategoriesList = Object.values(
    ElectricityBillInNameOfLandloadSubCategories
  );

  const mfaRidersSelectLabelsAndValues = getLabelsAndValuesForSelect(
    mfaRiderSubCategoriesList,
    mfaRiderSubCategoriesList
  );

  const nocForGstSelectLabelsAndValues = getLabelsAndValuesForSelect(
    nocForGstSubCategoriesList,
    nocForGstSubCategoriesList
  );
  const electricityBillInNameOfLandloadSelectLabelsAndValues =
    getLabelsAndValuesForSelect(
      electricityBillInNameOfLandloadSubCategoriesList,
      electricityBillInNameOfLandloadSubCategoriesList
    );
  const isAppliedOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false }
  ];
  const config = {
    [validDocumentTypes.preAgreementDocs]: [
      {
        label: "Sub Document*",
        name: "documentType",
        type: "select",
        placeholder: "Select document type",
        value: formDetails.documentType,
        error: errors.documentType,
        options: preAgreementSelectLabelsAndValues,
        helperText: errors.documentType ? "Required" : ""
      }
    ],
    [validDocumentTypes.agreementAndPostAgreementDocs]: [
      {
        label: "Sub Document*",
        name: "documentType",
        placeholder: "Select document type",
        type: "select",
        value: formDetails.documentType,
        error: errors.documentType,
        options: agreementAndPostAgreementLabelsAndValues,
        helperText: errors.documentType ? "Required" : ""
      }
    ],
    [validDocumentTypes.license]: [
      {
        label: "License Type*",
        name: "licenseType",
        type: "select",
        placeholder: "Select license type",
        value: formDetails.licenseType,
        error: errors.licenseType,
        options: cocoAcquiredLicensesLabels,
        helperText: errors.licenseType ? "Required" : ""
      },
      {
        label: "Is Applied",
        name: "isApplied",
        type: "select",
        placeholder: "Is Applied",
        value: formDetails.isApplied,
        error: errors.isApplied,
        options: isAppliedOptions,
        disabled: isEditingDoc && !!docs?.length
      },
      {
        label: "Upload Document",
        name: "docs",
        type: "upload",
        value: formDetails.licenseUpload,
        error: errors.licenseUpload,
        helperText: errors.licenseUpload ? "Required" : "",
        documentSavingKey: "document",
        uploadType: "licenceType",
        notUploadCheckBox: showCocoAcquiredLicenseTypeBoxInForm(
          formDetails,
          storeType
        ),
        notUploadKey: "notApplicable"
      }
    ],
    [validDocumentTypes.mfaRider]: [
      {
        label: "Sub Document*",
        name: "documentType",
        type: "select",
        placeholder: "Select document typr",
        value: formDetails.documentType,
        error: errors.documentType,
        options: mfaRidersSelectLabelsAndValues,
        helperText: errors.documentType ? "Required" : ""
      }
    ],
    [validDocumentTypes.nocForGst]: [
      {
        label: "Sub Document*",
        name: "documentType",
        type: "select",
        placeholder: "Select document type",
        value: formDetails.documentType,
        error: errors.documentType,
        options: nocForGstSelectLabelsAndValues,
        helperText: errors.documentType ? "Required" : ""
      }
    ],
    [validDocumentTypes.electricityBillInNameOfLandload]: [
      {
        label: "Sub Document*",
        name: "documentType",
        type: "select",
        placeholder: "Select document type",
        value: formDetails.documentType,
        error: errors.documentType,
        options: electricityBillInNameOfLandloadSelectLabelsAndValues,
        helperText: errors.documentType ? "Required" : ""
      }
    ]
  };
  switch (formDetails?.type?.value) {
    case validDocumentTypes.preAgreementDocs:
      preAgreementDocsConfig(formDetails, config, errors);
      break;
    case validDocumentTypes.agreementAndPostAgreementDocs:
      agreementAndPostAgreementDocsConfig(formDetails, config, errors);
      break;
    case validDocumentTypes.license:
      if (!formDetails?.notApplicable) {
        config[validDocumentTypes.license].splice(
          1,
          0,
          {
            label: "Start Date*",
            name: "startDate",
            type: "date",
            value: formDetails.startDate,
            error: errors.startDate,
            helperText: errors.startDate ? "Required" : ""
          },
          {
            label: "Expiry Date*",
            name: "endDate",
            type: "date",
            value: formDetails.endDate,
            error: errors.endDate,
            helperText: errors.endDate ? "Required" : ""
          }
        );
      } else {
        delete formDetails.endDate;
        delete formDetails.startDate;
      }
      if (
        formDetails?.licenseType?.value === validCocoAcquiredLicenses.others
      ) {
        config[validDocumentTypes.license] = [
          config[validDocumentTypes.license][0],
          {
            placeholder: "License Name",
            label: "License Name*",
            name: "licenseName",
            type: "text",
            value: formDetails.licenseName,
            error: errors.licenseName,
            helperText: errors.licenseName ? "Required" : ""
          },
          ...config[validDocumentTypes.license].slice(
            1,
            config[validDocumentTypes.license].length
          )
        ];
      } else {
        delete formDetails.licenseName;
      }
      break;
    case validDocumentTypes.mfaRider:
      mfaRiderConfig(formDetails, config, errors);
      break;
    case validDocumentTypes.waterTesting:
      waterTestingConfig(formDetails, config, errors);
      break;
    case validDocumentTypes.nocForGst:
      nocForGstConfig(formDetails, config, errors);
      break;
    case validDocumentTypes.electricityBillInNameOfLandload:
      electricityBillInNameOfLandloadConfig(formDetails, config, errors);
      break;
    default:
      break;
  }
  return config;
};
